import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    descriptionWrapper: {
        display: "flex",
        gap: theme.spacing(2),
        alignItems: "center",
        fontWeight: 600,
    },
    textRed: {
        color: theme.palette.error.main,
    },
}));
